import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { FakeDropdown } from '../FakeDropdown/FakeDropdown';
import { parseUrl, stringifyUrl } from 'query-string';

@Component
export class BlogMain extends ThemeComponent {
    @Ref() fakeDropdown!: FakeDropdown;

    init() {

        // Listen for fake dropdown change
        this.$subscribe(this.fakeDropdown.onChange, (tag) => {
            this.handleTagSelected(tag);
        });
    }

    handleTagSelected(tag: string) {

        // Ensure correct URL is used - no appended tags
        const parts = window.location.href.split('/');
        const parentHref = `${window.location.origin}/${parts[3]}/${parts[4]}`;

        // Remove page params from URL
        const { url, query } = parseUrl(parentHref, { decode: false });
        const newUrl = stringifyUrl({
            url: url,
            query: {
                ...query,
                page: undefined
            }
        }, { arrayFormat: 'none', encode: false });

        // Update URL
        if(tag === 'default') {
            window.location.replace(newUrl);
        } else {
            window.location.replace(`${newUrl}/tagged/${tag}`);
        }
    }
}
